<template>
  <div @touchstart="touchStart" @touchmove="touchMove">
    <div class="app-content">
      <div class="header">
        <Header v-if="$route.path !== '/login'" />
      </div>
      <div class="content">
        <!-- <OrderLists v-if="brandID" /> -->
        <!-- <router-view v-if="brandID" /> -->
        <router-view />
      </div>
      <b-modal
        v-model="isShowModalOverLay"
        no-fade
        hide-footer
        hide-header
        centered
        size="sm"
      >
        <div class="text-center">
          <img
            src="@/assets/images/loading.svg"
            alt="loading"
            class="my-2 loading-icon"
          />
          <div class="textc-primary">{{ $t("pleaseWait") }}</div>
        </div>
      </b-modal>
    </div>
    <ModalPressAgainToExit ref="modalPressAgainToExit" />
  </div>
</template>

<script>
import Header from "@/views/Layouts/Header.vue";
import iconFacebook from "@/assets/images/facebook.png";
import iconLine from "@/assets/images/line.png";
import iconInstagram from "@/assets/images/instagram.png";
import iconWeb from "@/assets/images/internet.png";
import ModalPressAgainToExit from "@/components/modal/ModalPressAgainToExit.vue";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    Header,
    ModalPressAgainToExit
  },
  data() {
    return {
      brandId: null,
      config: {},
      forceRefresh: true,
      isOrder: false,
      pathUrl: this.$baseUrl,
      chatChannelList: [
        { id: 0, name: "All Channel", imageUrl: "" },
        { id: 1, name: "Facebook", imageUrl: iconFacebook },
        { id: 2, name: "Line", imageUrl: iconLine },
        { id: 3, name: "Instagram", imageUrl: iconInstagram },
        { id: 4, name: "Web", imageUrl: iconWeb }
      ],
      xDown: null,
      yDown: null,
      isLoadingStatusAdmin: false
    };
  },
  created() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    // window.addEventListener("beforeunload", this.onStatusChangeEnd);

    if (!this.$cookies.isKey("language")) {
      this.$cookies.set("language", this.$defaultLanguage);
    }
    this.$store.commit("UPDATE_LANGUAGE", this.$cookies.get("language"));
    moment.locale(this.$cookies.get("language"));

    this.isOrder = this.$route.meta.isOrder;
    if (this.isOrder == true) {
      this.pathUrl = this.$baseUrlOrder;
    }
    this.brandId = this.$route.query.brandID;
    this.getAllBrand(this.brandId);
    if (this.brandId) {
      this.$store.dispatch("setBrand", this.brandId);
    }
  },
  computed: {
    ...mapGetters({
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      brandID: "getBrand",
      isStore: "getStoreFlag",
      isShowModalOverLay: "getIsLoading",
      activePanel: "getActivePanel",
      agentSelected: "getAgentSelected",
      screenSize: "getScreenSize",
      chatModeList: "getChatModeCount",
      brandLists: "getBrandLists",
      selectedBrand: "getSelectedBrand",
      adminProfile: "getChatAdminProfile",
      isChangedStatus: "getIsChangedStatus"
    })
  },
  mounted() {
    // sessionStorage.setItem("isReload", "true");
    // window.addEventListener("beforeunload", this.onStatusChangeEnd);
  },
  methods: {
    handleResize() {
      let screenSize = {
        width: window.innerWidth,
        height: window.innerHeight
      };
      this.$store.dispatch("setScreenSize", screenSize);
    },
    touchStart(evt) {
      this.xDown = evt.touches[0].clientX;
      this.yDown = evt.touches[0].clientY;
    },
    touchMove(evt) {
      if (!this.xDown || !this.yDown) {
        return;
      }

      var xUp = evt.touches[0].clientX;
      var yUp = evt.touches[0].clientY;

      var xDiff = this.xDown - xUp;
      var yDiff = this.yDown - yUp;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        /*most significant*/
        if (xDiff > 0) {
          /* left swipe */
          console.log("slideRight");
          if (this.activePanel < 3 && this.agentSelected)
            this.$store.dispatch("setActivePanel", this.activePanel + 1);
        } else {
          /* right swipe */
          console.log("slideLeft");
          if (this.activePanel > 1) {
            this.$store.dispatch("setActivePanel", this.activePanel - 1);

            // if (this.activePanel == 1)
            //   this.$store.dispatch("setAgentSelected", false);
          }
        }
      } else {
        if (yDiff > 0) {
          /* up swipe */
        } else {
          /* down swipe */
        }
      }
      /* reset values */
      this.xDown = null;
      this.yDown = null;
    },
    async onStatusChange(status = false) {
      await this.$store.dispatch("updateChatAdminProfileIsAvailable", status);
      this.isLoadingStatusAdmin = false;
    },
    async getAllBrand(brandId) {
      var path = "/api/brand/list";
      // if (this.isOrder) {
      path = "/api/admin/brand";
      // }
      await this.$axios.get(this.pathUrl + path).then(async response => {
        if (response.data.result === 1) {
          await this.$store.dispatch("setBrandLists", response.data.detail);

          if (response.data.detail.length !== 0) {
            this.$store.dispatch("setUserPermission", true);
            if (!brandId) {
              brandId = response.data.detail[0].id;
              this.setSelectBrand(brandId);
              // this.getBrandConfig(brandId);
              // this.getPermission(brandId);
              this.$router
                .replace({
                  path: "/",
                  query: { brandID: brandId }
                })
                .catch(err => {
                  console.log("err", err);
                });
            } else if (brandId) {
              if (!this.textValidate(brandId)) {
                this.setSelectBrand(response.data.detail[0].id);
                brandId = response.data.detail[0].id;
                this.$router
                  .replace({
                    path: "/",
                    query: { brandID: brandId }
                  })
                  .catch(err => {
                    console.log("err", err);
                  });
              } else {
                var checkBrandFlag = this.brandLists.some(
                  el => el.id === Number(brandId)
                );
                if (!checkBrandFlag) {
                  brandId = response.data.detail[0].id;
                  this.setSelectBrand(brandId);
                  this.$router
                    .replace({
                      path: "/",
                      query: { brandID: brandId }
                    })
                    .catch(err => {
                      console.log("err", err);
                    });
                } else {
                  this.setSelectBrand(this.brandId);
                }

                // this.$emit("OrderLists");
              }
              // this.getBrandConfig(brandId);
              // this.getPermission(brandId);
            }
            //this.$emit("OrderLists");
            await this.$store.dispatch(
              "setBrandSetting",
              response.data.detail.find(ele => ele.id == brandId)
            );
            await this.$store.dispatch("getChatModeListCount");
            await this.$store.dispatch("setChatModeLabel");
            if (this.chatModeList.length > 0) {
              if (!this.$route.query.mode) {
                this.$router.replace({
                  query: {
                    ...this.$route.query,
                    mode: encodeURIComponent(
                      this.chatModeList[0].name.toLowerCase()
                    )
                  }
                });
              }
              const queryMode = this.$route.query.mode
                ? decodeURIComponent(this.$route.query.mode.toLowerCase())
                : null;
              let targetMode = null;
              if (queryMode) {
                targetMode = this.chatModeList.find(
                  item => item.name.toLowerCase() === queryMode
                );
              }

              if (!targetMode) {
                if (this.$route.query.mode) {
                  const rest = { ...this.$route.query };
                  delete rest.mode;
                  this.$router.replace({ query: rest }).catch(() => {});
                }

                targetMode = this.chatModeList[0];
              }
              await this.$store.dispatch("setChatMode", targetMode.modeId);
            }
          } else {
            if (this.$route.path !== "/AccessDenied") {
              this.$router.push({
                path: "/AccessDenied"
              });
            }
          }
        }
      });
    },
    setSelectBrand(brandId) {
      this.$store.dispatch("setBrand", brandId);
      let filtered = this.brandLists.filter(ele => ele.id == brandId);
      if (filtered.length) {
        this.$store.dispatch("setSelectedBrand", filtered[0]);
      }
    },
    handleForcefresh() {
      this.forceRefresh = false;
      this.$nextTick(() => {
        this.forceRefresh = true;
      });
    },
    textValidate(text) {
      var textReg = /^\d+$/;
      return textReg.test(text);
    },
    getPermission(brandId) {
      this.$axios
        .post(this.pathUrl + "/api/User/Brand/" + brandId + "/Permission")
        .then(response => {
          if (response.data.result === 1) {
            this.$store.dispatch("setPermission", response.data.detail.finance);
          } else {
            alert(response.data.message);
          }
        });
    },
    getBrandConfig(brandId) {
      this.$axios
        .get(this.pathUrl + "/api/brand/" + brandId + "/config")
        .then(response => {
          this.config = response.data.detail;
          //this.$store.dispatch("setPermission", response.data.detail.finance);
          this.$store.dispatch("setBrandLogo", response.data.detail.logo);
          this.$store.dispatch(
            "setTheOneCardFlag",
            response.data.detail.useThe1Card
          );
          this.$store.dispatch("setBrandName", response.data.detail.name);
          this.$store.dispatch(
            "setStoreFlag",
            response.data.detail.isStoreFulfillment
          );
          this.$store.dispatch(
            "setBrandColor",
            response.data.detail.colorThemeMain
          );
        });
    },
    async onStatusChangeEnd() {
      if (this.isChangedStatus) {
        // const entries = performance.getEntriesByType("navigation");
        // const navType = entries.length ? entries[0].type : null;
        // console.log("onStatusChangeEnd", navType);

        // // Safari บางเวอร์ชันไม่มี navigation.type → fallback ไปใช้ performance.navigation
        // const oldNavType = performance.navigation
        //   ? performance.navigation.type
        //   : null;
        // // 0 = navigate, 1 = reload, 2 = back_forward
        // if (
        //   navType === "reload" ||
        //   navType === "back_forward" ||
        //   oldNavType === 1 ||
        //   oldNavType === 2
        // ) {
        //   // เป็นการ reload หรือ back/forward → ไม่ยิง API
        //   return;
        // }

        if (sessionStorage.getItem("isReload")) {
          // เคลียร์ค่าเพื่อเตรียมรอบหน้า
          sessionStorage.removeItem("isReload");
          return; // ไม่ยิง API
        } else {
          const url = this.$chatBaseUrl + "/user/staff/updateStatus";
          const data = {
            brandId: `${this.brandID}`,
            externalId: this.adminProfile.externalId,
            isAvailable: false
          };

          try {
            await fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                ...this.$headersChat
              },
              body: JSON.stringify(data),
              keepalive: true
            });
          } catch (error) {
            console.error("Failed to end chat:", error);
          }
        }
      }
    }
  },
  beforeDestroy() {
    // window.removeEventListener("beforeunload", this.onStatusChangeEnd);
  },
  async destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style lang="scss" scoped>
div:has(.show) {
  z-index: 1060 !important;
}
</style>
